import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowDoubleRight = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M10.6667 8.83333L4 13V3L10.6667 7.16667V3H13.3333V13H10.6667V8.83333Z",
		fill: "currentColor"
	})
});
export default SvgArrowDoubleRight;
